<template>
    <v-sheet class="menu-dropdown" tag="nav" position="absolute" width="100%" color="transparent" style="top: 0">
        <v-slide-y-transition>
            <div v-show="selectedMenuItem === -1">
                <v-sheet color="secondary" height="62" class="d-flex align-center justify-end">
                    <v-container fluid class="py-0 px-md-10">
                        <my-profile-link-button
                            :is-logged-in="isLoggedIn"
                            :title="profilePageInfo?.displayName"
                            :page-link="profilePageLink"
                            link-type="account"
                        />
                        <my-profile-link-button
                            :is-logged-in="isLoggedIn"
                            :title="myPageInfo?.displayName"
                            :page-link="myPageLink"
                            link-type="page"
                        />
                        <logout-link-button
                            :menu-items="menuItems"
                            :is-logged-in="isLoggedIn"
                            :current-language="currentLanguage"
                            height="32"
                        />
                    </v-container>
                </v-sheet>
            </div>
        </v-slide-y-transition>
    </v-sheet>
</template>

<script setup lang="ts">
import { MenuStructure } from '../../composables/MenuProvider';
import { LogoutLinkButton, MyProfileLinkButton } from '..';
import { ProfileInfo } from '../../models';
import { useProfileNavigation } from '../../composables';

interface Props {
    profileInfo?: ProfileInfo;
    menuItems: MenuStructure;
    isLoggedIn: boolean;
    selectedMenuItem?: number;
    currentLanguage: string;
}
const props = defineProps<Props>();

const { profilePageLink, profilePageInfo, myPageInfo, myPageLink } = useProfileNavigation(props);
</script>

<style lang="scss">
.menu-dropdown {
    .v-container {
        display: flex;
        justify-content: flex-end;
    }
}
</style>
